import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListDriverRequests extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/driver-requests/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'number'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    let { driverRequests } = this.props
    driverRequests = [...driverRequests]

    const data = driverRequests.map((driverRequest, index) => {
      // format date from db
      driverRequest.created_date = moment(new Date(driverRequest.created_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${driverRequest.id}${index}`,
          job: {
            job_id: driverRequest.job_id,
            job_type: driverRequest.job_type,
            number: driverRequest.number,
            id: driverRequest.id
          }
        },
        driverRequest
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Driver Requests</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListDriverRequests



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListDriverRequests.js